// @owners { team: patients }
import {
  AddOnsEndpoint,
  type AddOnsEndpointAddToShipmentRequest,
} from '@alto/scriptdash/alto/patient_app/add_ons/v1/add_ons_endpoint';
import { apiEndpointHandler } from '~shared/helpers/api';
import { useMutation } from '~shared/react-query';

const AddOnsApi = AddOnsEndpoint(apiEndpointHandler);
export const ADD_ONS_ADD_TO_SHIPMENT_MUTATION_KEY = ['addOnsAddToShipment'];

export const useAddOnsAddToShipment = () => {
  return useMutation({
    mutationFn: (params: AddOnsEndpointAddToShipmentRequest) => AddOnsApi.addToShipment(params),
    mutationKey: ADD_ONS_ADD_TO_SHIPMENT_MUTATION_KEY,
  });
};
